<template>
  <router-view />
</template>

<script>
export default {
  name: "SampleTypeSingle"
}
</script>